<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h2 class="chaptitle">Contents</h2>
<h2 class="toc"><a href="#/xhtml/04_Prefatory"><em class="italic">Prefatory Note</em></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter01">The American Way</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter02">The Rights of the Common Man</a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample">Young America</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample">The Inter-American Order</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample">Not Bread Alone</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample">Foreign Tyranny</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample">The Four Freedoms</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample">The Enemy Within</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter09" title="Link target outside of Sample">Government with a Soul</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter10" title="Link target outside of Sample">For Peace I Shall Labor</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter11" title="Link target outside of Sample">True Education</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter12" title="Link target outside of Sample">Dynamic Democracy</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter13" title="Link target outside of Sample">We Belong to Many Races</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Author" title="Link target outside of Sample">About the Author</span></h2>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7e9b2057